import React, { useState, useEffect, useCallback } from "react";
import { supabase } from "./supabaseClient";
import { getLevelForXP } from "./Gamification";

function Leaderboard({ user }) {
  const [fighters, setFighters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState("xp");

  const loadLeaderboard = useCallback(async () => {
    setLoading(true);
    const orderCol = tab === "xp" ? "xp" : tab === "streak" ? "streak" : "total_uploads";
    const { data: stats } = await supabase
      .from("fighter_stats")
      .select("*, profiles(full_name, avatar_url, boxing_style)")
      .order(orderCol, { ascending: false })
      .limit(20);
    setFighters(stats || []);
    setLoading(false);
  }, [tab]);

  useEffect(() => {
    loadLeaderboard();
  }, [loadLeaderboard]);

  const tabs = [
    { id: "xp", label: "XP" },
    { id: "streak", label: "Streak" },
    { id: "uploads", label: "Sessions" }
  ];

  return (
    <div style={{fontFamily:"Inter, sans-serif"}}>
      <h2 style={{fontFamily:"Bebas Neue, sans-serif",fontSize:"2.5rem",letterSpacing:"2px",background:"linear-gradient(135deg, #e94560, #ff6b35)",WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent",marginBottom:"8px",marginTop:0}}>LEADERBOARD</h2>
      <p style={{color:"#555",marginBottom:"25px",fontSize:"0.9rem"}}>Top fighters ranked globally</p>

      <div style={{display:"flex",gap:"8px",marginBottom:"25px"}}>
        {tabs.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)} style={{
            padding:"10px 20px",borderRadius:"10px",cursor:"pointer",
            fontFamily:"Inter, sans-serif",fontSize:"0.9rem",fontWeight:"600",
            border: tab===t.id ? "none" : "1px solid rgba(255,255,255,0.08)",
            background: tab===t.id ? "linear-gradient(135deg, #e94560, #ff6b35)" : "rgba(255,255,255,0.03)",
            color: tab===t.id ? "white" : "#666",
            boxShadow: tab===t.id ? "0 4px 15px rgba(233,69,96,0.3)" : "none"
          }}>{t.label}</button>
        ))}
      </div>

      {loading ? (
        <div style={{textAlign:"center",padding:"40px"}}>
          <p style={{color:"#555"}}>Loading rankings...</p>
        </div>
      ) : fighters.length === 0 ? (
        <div style={{backgroundColor:"rgba(255,255,255,0.02)",padding:"50px",borderRadius:"16px",textAlign:"center",border:"1px solid rgba(255,255,255,0.05)"}}>
          <div style={{fontSize:"3rem",marginBottom:"15px"}}>🏆</div>
          <p style={{color:"#555"}}>No fighters yet. Be the first on the leaderboard!</p>
        </div>
      ) : (
        <div>
          {fighters.map((fighter, index) => {
            const isMe = fighter.user_id === user.id;
            const level = getLevelForXP(fighter.xp || 0);
            const name = fighter.profiles?.full_name || "Anonymous Fighter";
            const avatar = fighter.profiles?.avatar_url;
            const style = fighter.profiles?.boxing_style;
            const value = tab === "xp" ? fighter.xp + " XP" : tab === "streak" ? fighter.streak + " days" : fighter.total_uploads + " sessions";
            const medal = index === 0 ? "🥇" : index === 1 ? "🥈" : index === 2 ? "🥉" : null;

            return (
              <div key={fighter.id} style={{
                display:"flex",alignItems:"center",gap:"15px",
                padding:"16px 20px",borderRadius:"14px",marginBottom:"10px",
                background: isMe ? "linear-gradient(135deg, rgba(233,69,96,0.12), rgba(255,107,53,0.06))" : index < 3 ? "rgba(255,255,255,0.04)" : "rgba(255,255,255,0.02)",
                border: isMe ? "1px solid rgba(233,69,96,0.3)" : index < 3 ? "1px solid rgba(255,255,255,0.08)" : "1px solid rgba(255,255,255,0.04)"
              }}>
                <div style={{width:"35px",textAlign:"center",flexShrink:0}}>
                  {medal ? <span style={{fontSize:"1.4rem"}}>{medal}</span> : <span style={{color:"#444",fontSize:"0.9rem",fontWeight:"600"}}>#{index + 1}</span>}
                </div>
                <div style={{width:"42px",height:"42px",borderRadius:"50%",background: avatar ? "transparent" : "linear-gradient(135deg, #e94560, #ff6b35)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"1.1rem",overflow:"hidden",flexShrink:0,border:"2px solid rgba(255,255,255,0.08)"}}>
                  {avatar ? <img src={avatar} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}} /> : "🥋"}
                </div>
                <div style={{flex:1}}>
                  <p style={{color: isMe ? "#e94560" : "white",margin:0,fontWeight:"600",fontSize:"0.95rem"}}>{name}{isMe ? " (You)" : ""}</p>
                  <p style={{color:"#555",margin:"2px 0 0 0",fontSize:"0.78rem",textTransform:"capitalize"}}>{level.name} • {style?.replace("_"," ") || "Fighter"}</p>
                </div>
                <div style={{textAlign:"right",flexShrink:0}}>
                  <p style={{color: index < 3 ? "#e94560" : "white",margin:0,fontWeight:"700",fontSize:"1rem"}}>{value}</p>
                  <p style={{color:"#444",margin:"2px 0 0 0",fontSize:"0.75rem"}}>Level {level.level}</p>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default Leaderboard;
